/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Validation_Damage_Amount_RequiredInputs */

const en_case_validation_damage_amount_required = /** @type {(inputs: Case_Validation_Damage_Amount_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Value is required.`)
};

const pt_br2_case_validation_damage_amount_required = /** @type {(inputs: Case_Validation_Damage_Amount_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O valor é obrigatório.`)
};

/**
* | output |
* | --- |
* | "Value is required." |
*
* @param {Case_Validation_Damage_Amount_RequiredInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_validation_damage_amount_required = /** @type {((inputs?: Case_Validation_Damage_Amount_RequiredInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Validation_Damage_Amount_RequiredInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_validation_damage_amount_required(inputs)
	return pt_br2_case_validation_damage_amount_required(inputs)
});